import React from "react";
import { motion } from "framer-motion";

const skills = [
  "ReactJS",
  "Redux",
  "HTML",
  "CSS",
  "Javascript",
  "ExpressJS",
  "MongoDB",
  "NodeJS",
  "Sass",
];
const animation = {
  offscreen: {
    x: 300,
    rotate: 120,
    opacity: 0,
  },
  onscreen: {
    x: 0,
    rotate: 0,
    opacity: 1,
    transition: {
      type: "spring",
      bounce: 0.2,
      duration: 1,
    },
  },
};
const SkillsComponent = () => {
  return (
    <>
      <section className="pb-20 lg:pb-0 lg:h-96  select-none">
        <motion.h1
          whileHover={{}}
          className="text-5xl mb-20 p-4 lg:p-6 lg:text-6xl rounded-3xl w-4/5 lg:w-2/3 mx-auto bg-violet-100 text-violet-900 uppercase text-center"
        >
          Key Skills
        </motion.h1>
        <motion.div
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: true, amount: 0.6 }}
          className="flex mx-auto text-gray-100 flex-col lg:flex-row text-center w-11/12"
        >
          {skills.map((data) => (
            // <h1 className="text-3xl p-5 w-3/5 mx-auto lg:p-10 m-5 lg:m-0 rounded-3xl transition-all hover:bg-violet-500 cursor-pointer translate-x-100 hover:translate-x-100 duration-300">
            //   {data}
            // </h1>
            <motion.h1
              variants={animation}
              class="group relative text-3xl font-semibold md:xl p-5 w-3/5 mx-auto lg:p-10 lg:text-xl 2xl:text-3xl xl:p-7 m-5 lg:m-2 rounded-3xl break-words"
            >
              <motion.div
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.9 }}
                className="absolute rounded-xl inset-0 w-3 bg-violet-400 transition-all duration-[500ms] ease-out xl:w-2 group-hover:w-full"
              ></motion.div>
              <span class="relative text-gray-400 group-hover:text-white cursor-pointer">
                {data}
              </span>
            </motion.h1>
          ))}
        </motion.div>
        {/* <div className="w-2/4 mx-auto">
        <h1 className="text-5xl my-10 text-center">Others</h1>
        <div className="flex  justify-evenly text-3xl">
          <p>Adobe Illustrator</p>
          <p>Adobe Photoshop</p>
          <p>Figma</p>
        </div>
      </div> */}
      </section>
    </>
  );
};

export default SkillsComponent;
